declare var google: any;

import { Component } from '@angular/core';
import jwtDecode from 'jwt-decode';
import { AppConfig } from 'src/app/helpers/app.config';

@Component({
  selector: 'ct-login-google',
  templateUrl: './login-google.component.html',
  styleUrls: ['./login-google.component.scss']
})
export class LoginGoogleComponent {

  private clientId = '';
  private redirectUri = '';

  constructor() {
    this.clientId = AppConfig.settings.GOOGLE_ACCOUNT;
    this.redirectUri = AppConfig.settings.HOME;
  }

  async init() {
    await this.initialize().then((_) => {

      google.accounts.id.initialize({
        client_id: AppConfig.settings.GOOGLE_ACCOUNT,
        callback: async (resp) =>
          await this.handleCredentialResponse(resp, this.clientId, this.redirectUri),
      });

      google.accounts.id.renderButton(
        document.getElementById('googleLoginBtn'),
        { theme: 'outline', size: 'large' }
      );

      google.accounts.id.prompt();

    });
  }

  async handleCredentialResponse(response, clientId, redirectUri) {

    const userEmail = jwtDecode(response['credential'])['email'];

    sessionStorage.setItem(
      'google_credential_response',
      JSON.stringify({
        clientId: response['clientId'],
        id_token: response['credential'],
        selectBy: response['select_by'],
      })
    );

    window.location.href =
      `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=${clientId}&` +
      `redirect_uri=${redirectUri}&` +
      `login_hint=${userEmail}&` +
      `response_type=token&` +
      `scope=https://www.googleapis.com/auth/userinfo.profile%20` +
      `https://www.googleapis.com/auth/userinfo.email%20` +
      `https://www.googleapis.com/auth/admin.directory.user.readonly&` +
      `include_granted_scopes=true&` +
      `state=pass-through%20value`;
  }

  async initialize(): Promise<void> {
    await new Promise((resolve) => {
      const gapiScript = document.createElement('script');
      gapiScript.src = 'https://accounts.google.com/gsi/client';
      gapiScript.async = true;
      gapiScript.defer = true;
      gapiScript.onload = () => {
        resolve(null);
      };
      document.head.appendChild(gapiScript);
    });
  }

}
